import {
  Button,
  Col,
  Descriptions,
  Divider,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import {HeaderCustom, HeaderPrintForm} from "components/common";
import Sign from "components/common/PrintForm/Sign/Sign";
import React, {useEffect, useRef, useState} from "react";
import ReactToPrint from "react-to-print";
import {useAppSelector} from "redux/hooks";
import "./config";
import {columns} from "./config";
import "./BillModal.scss";
import {
  formatDateToString,
  formatToCurrencyType,
  formatToCurrencyTypeFloor,
  formatToCurrencyTypeToFixed,
  getAge,
} from "helper/common";
import {CURRENCY_LOCALE, FORMAT_TIME} from "types/enums";
import GlassesPrescriptionPrint from "pages/Refractive/InforDetails/PrintForm/GlassesPrescription/GlassesPrescription";
const BillModal = props => {
  const {closeModal} = props;
  const printRef = useRef<any>();
  const [type, setType] = useState(1);
  const detailBill = useAppSelector(state => state.glassKiot.detailBill);
  const listStore = useAppSelector(state => state.glassStore.listStore);
  useEffect(() => {
    // console.log(detailBill);
  }, [detailBill]);
  const fields1 = [
    {label: "Họ và tên", value: detailBill?.glassesSalesDto?.hoTen},
    {
      label: "Ngày sinh",
      value: formatDateToString(
        detailBill?.glassesSalesDto?.ngaySinh,
        FORMAT_TIME.dayFull
      ),
    },
    {label: "Tuổi", value: getAge(detailBill?.glassesSalesDto?.ngaySinh)},
    {
      label: "Giới tính",
      value:
        detailBill?.glassesSalesDto?.gioiTinh == "0"
          ? "Nam"
          : detailBill?.glassesSalesDto?.gioiTinh == "1"
          ? "Nữ"
          : "--",
    },
    {label: "Điện thoại", value: detailBill?.glassesSalesDto?.dienThoai},
  ];
  const fields2 = [
    {label: "Mã bệnh nhân", value: detailBill?.glassesSalesDto?.maBenhNhan},
    {label: "Mã phiếu khám", value: detailBill?.glassesSalesDto?.idPhieuKham},
    {label: "CNKX", value: detailBill?.glassesSalesDto?.tenBacSy},
    // { label: "Lý do khám", value: detailBill?.glassesSalesDto?.description },
    {label: "Địa chỉ", value: detailBill?.glassesSalesDto?.diaChi},
    {label: "Ghi chú", value: detailBill?.glassesSalesDto?.ghiChu},
  ];
  useEffect(() => {
    const setHeader = () => {
      const storeName = listStore?.find(
        e => e?.id == detailBill?.glassesSalesDto?.storeId
      )?.name;
      if (
        storeName == "Kho kính An Nam - Vinmec" ||
        storeName == "Kho kính Alina - Vinmec"
      ) {
        setType(2);
      } else {
        setType(1);
      }
    };
    setHeader();
  }, [detailBill]);
  const onPrint = async () => {
    window.print();
  };

  return (
    <div className="bill-modal print-form">
      <div ref={printRef} className="print-modal">
        <HeaderPrintForm type={type}></HeaderPrintForm>
        <div>
          <div>
            <Row justify={"center"}>
              <Typography.Title
                style={{
                  fontWeight: "700",
                  fontSize: 30,
                }}
              >
                HÓA ĐƠN KÍNH
              </Typography.Title>
            </Row>
            <Row>
              <Col span={10}>
                <Descriptions
                  size="small"
                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}
                >
                  {/* <Row wrap={true} style={{width: "100%"}}> */}
                  {fields1 &&
                    fields1.map(e => (
                      // <Col span={12}>
                      <Descriptions.Item label={e.label}>
                        {e?.value ?? "--"}
                      </Descriptions.Item>
                      // </Col>
                    ))}
                  {/* </Row> */}
                </Descriptions>
              </Col>
              <Col span={10}>
                <Descriptions
                  size="small"
                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}
                >
                  {/* <Row wrap={true} style={{width: "100%"}}> */}
                  {fields2 &&
                    fields2.map(e => (
                      // <Col span={12}>
                      <Descriptions.Item label={e.label}>
                        {e?.value ?? "--"}
                      </Descriptions.Item>
                      // </Col>
                    ))}
                  {/* </Row> */}
                </Descriptions>
              </Col>
              <Col span={4}>
                <Row>
                  <QRCode
                    value={detailBill?.glassesSalesDto?.maBenhNhan}
                    size={120}
                  />
                </Row>
              </Col>
            </Row>
          </div>
          {(detailBill?.glassesSalesDto?.glassesPrescription?.left ||
            detailBill?.glassesSalesDto?.glassesPrescription?.right) && (
            <div>
              <div style={{gap: "8px", display: "flex"}}>
                <HeaderCustom title="Mắt phải"></HeaderCustom>
                <HeaderCustom title="Mắt trái"></HeaderCustom>
              </div>
              <GlassesPrescriptionPrint
                detailPhieu={detailBill?.glassesSalesDto?.glassesPrescription}
              />
            </div>
          )}

          <div className="container2" style={{marginBottom: 12}}>
            <Row>
              <Typography.Text
                style={{
                  fontWeight: "700",
                  fontSize: 20,
                  marginBottom: 8,
                }}
              ></Typography.Text>
            </Row>
            <Table
              bordered
              columns={columns}
              dataSource={detailBill?.listGlassesSalesDetailDto}
              pagination={false}
              className="table-print"
            ></Table>
          </div>

          <div className="container2" style={{marginBottom: 12}}>
            <Row justify={"space-between"}>
              <Col sm={12} md={12} xl={12}>
                <Space direction="vertical" size={2}>
                  <div>
                    Số tiền miễn giảm:{" "}
                    <span className="value">
                      {formatToCurrencyTypeToFixed(
                        detailBill?.glassesSalesDto.giamGia,
                        0,
                        CURRENCY_LOCALE.TYPE_DE
                      )}
                      đ
                    </span>
                  </div>
                  <div>
                    Lý do miễn giảm: {detailBill?.glassesSalesDto.lyDoGiamGia}
                  </div>
                  <div>
                    Hình thức thanh toán:{" "}
                    {detailBill?.glassesSalesDto.paymentsName}
                  </div>
                </Space>
              </Col>
              <Col sm={12} md={12} xl={12} style={{textAlign: "end"}}>
                <Space direction="vertical" size={2}>
                  <div>
                    <span className="label">Thành tiền:</span>{" "}
                    <span className="value">
                      {formatToCurrencyTypeToFixed(
                        detailBill?.glassesSalesDto.thanhTien,
                        0,
                        CURRENCY_LOCALE.TYPE_DE
                      )}
                      đ
                    </span>
                  </div>
                  <div>
                    <span className="label">Tổng GT giảm:</span>{" "}
                    <span className="value">
                      {formatToCurrencyTypeToFixed(
                        detailBill?.glassesSalesDto.giamGia,
                        0,
                        CURRENCY_LOCALE.TYPE_DE
                      )}
                      đ
                    </span>
                  </div>
                  <div>
                    <span className="label">Tổng GT đơn:</span>{" "}
                    <span className="value">
                      {formatToCurrencyTypeToFixed(
                        detailBill?.glassesSalesDto.tongTien,
                        0,
                        CURRENCY_LOCALE.TYPE_DE
                      )}
                      đ
                    </span>
                  </div>
                </Space>
              </Col>
            </Row>
          </div>

          <Sign
            time={detailBill?.glassesSalesDto?.thoiGianBan}
            style={{marginTop: 20}}
            span={8}
            nguoiThucHien={detailBill?.glassesSalesDto.nvBanHang}
            label="Nhân viên bán kính"
          ></Sign>
        </div>
      </div>
      <Row justify={"end"} className="footer">
        <Space direction="horizontal">
          <Button danger onClick={closeModal}>
            Hủy
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            bodyClass="bill-modal print-form"
            onAfterPrint={closeModal}
          />
        </Space>
      </Row>
    </div>
  );
};
export default BillModal;
